import React from 'react';
import { DevicePreview, DevicePreviewStatus } from '../types';
import { Body1 } from 'ui/theme';
import { Skeleton } from 'ui/skeleton';
import { Card } from 'ui/cardV2';
import { CardContent, EmptyGrid, GridContainer, ImageContainer } from './Styled';
import { NoResult } from 'ui/illustrations';
import { ImageZoomOverlay } from './ImageZoomOverlay';

interface DevicePreviewGridProps {
  devicePreviews: DevicePreview[];
  isLoading: boolean;
}

export const DevicePreviewGrid: React.FC<DevicePreviewGridProps> = ({
  devicePreviews,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <GridContainer>
        {Array.from({ length: 8 }, (_, index) => (
          <Card key={index}>
            <CardContent>
              <ImageContainer>
                <Skeleton height={250} width="100%" />
              </ImageContainer>
              <Skeleton height={24} width="100%" />
            </CardContent>
          </Card>
        ))}
      </GridContainer>
    );
  }

  if (!devicePreviews.length) {
    return (
      <EmptyGrid>
        <NoResult />
        <h4>There aren’t any previews to load</h4>
      </EmptyGrid>
    );
  }

  return (
    <GridContainer>
      {devicePreviews.map(({ id, thumbnail, display_name, status, os, screenshots }) => (
        <Card key={id}>
          <CardContent>
            <ImageContainer>
              {status === DevicePreviewStatus.Complete ? (
                <ImageZoomOverlay thumbnail={thumbnail} imageSrc={screenshots.default} />
              ) : (
                <Skeleton height={250} width="100%" />
              )}
            </ImageContainer>
            <Body1>
              {display_name} on {os}
            </Body1>
          </CardContent>
        </Card>
      ))}
    </GridContainer>
  );
};
